import Component from '@glimmer/component';

interface AtlasEditorFieldLabelComponentProps {
  label: string;
  subtext?: string;
  fieldType: 'text-input' | 'toggle' | 'checkbox' | 'text-area';
}

export default class AtlasEditorFieldLabelComponent extends Component<AtlasEditorFieldLabelComponentProps> {
  get className(): string {
    const clickableStyle = 'cursor-pointer';
    const rowStyle = 'flex items-center';

    switch (this.args.fieldType) {
      case 'toggle':
        return `justify-between  gap-2 ${rowStyle} ${clickableStyle}`;
      case 'checkbox':
        return `flex-row-reverse mr-auto gap-3 ${rowStyle} ${clickableStyle}`;
      default:
        return 'grid gap-2';
    }
  }
}
